/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#map[_ngcontent-%COMP%]{height:500px;width:100%}\n/*# sourceMappingURL=demand-areas.component.css.map*/"];
export { styles as styles };
